import { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(() => (localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null));
  const [user, setUser] = useState(() => (localStorage.getItem('authTokens') ? jwtDecode(localStorage.getItem('authTokens')) : null));
  const [loading, setLoading] = useState(true);

  const loginUser = async (e) => {
    e.preventDefault();
    let response = await fetch('  https://erp.mgmebuild.com/api/token/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 'username': e.target.username.value, 'password': e.target.password.value }),
    });
    let data = await response.json();
    if (response.status == 200) {
      let user_id = jwtDecode(data.access).user_id;
      let user_name = jwtDecode(data.access).username;
      let userLocation = jwtDecode(data.access).location;
      let userGroup = jwtDecode(data.access).groups;
      setAuthTokens(data);
      setUser(jwtDecode(data.access));
      localStorage.setItem('username', user_name);
      localStorage.setItem('user_login', true);
      localStorage.setItem('authTokens', JSON.stringify(data));
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('userLocation', userLocation);
      localStorage.setItem('userGroup', userGroup);
    if (userGroup == 'Admin') {
      window.location.href = '/';
    } else if (userGroup == 'Accounting') {
      window.location.href = '/account-menu/';
    } else if (userGroup == 'Hr') {
      window.location.href = '/hrms-menu/';
    } else if (userGroup == 'Crm'){
        window.location.href = '/crm-menu/';
    } else if (userGroup == 'Stores') {
      window.location.href = '/stores-menu/';
    } else {
      // Default redirection if needed
      window.location.href = '/';
    }
  } else {
    alert('Check your Credentials!');
  }
  };

  const logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem('authTokens');
    localStorage.removeItem('username');
    localStorage.removeItem('user_login');
    localStorage.removeItem('userLocation');
    localStorage.removeItem('userGroup');
    localStorage.removeItem('user_id');
  };

  const updateToken = useCallback(async () => {
    let response = await fetch('  https://erp.mgmebuild.com/api/token/refresh/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 'refresh': authTokens?.refresh }),
    });

    let data = await response.json();

    if (response.status == 200) {
      let user_id = jwtDecode(data.access).user_id;
      let user_name = jwtDecode(data.access).username;
      let userLocation = jwtDecode(data.access).location;
      let userGroup = jwtDecode(data.access).groups;
      setAuthTokens(data);
      setUser(jwtDecode(data.access));
      localStorage.setItem('username', user_name);
      localStorage.setItem('user_login', true);
      localStorage.setItem('authTokens', JSON.stringify(data));
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('userLocation', userLocation);
      localStorage.setItem('userGroup', userGroup);
    } else {
      logoutUser();
    }

    if (loading) {
      setLoading(false);
    }
  }, [authTokens, loading]);

  const contextData = {
    user: user,
    authTokens: authTokens,
    loginUser: loginUser,
    logoutUser: logoutUser,
  };

  useEffect(() => {
    if (loading) {
      updateToken();
    }

    let fourMinutes = 1000 * 60 * 4;
    let interval;

    if (authTokens) {
      interval = setInterval(() => {
        updateToken();
      }, fourMinutes);
    }

    return () => clearInterval(interval);
  }, [authTokens, loading, updateToken]);

  return (
    <AuthContext.Provider value={contextData} >
      {loading ? null : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
